import { ChangeEvent, useState } from "react";
import "./index.css";

interface IProps {
  onclkbtn: (n: string) => void;
}

export function PhoneScreen(props: IProps) {
  const [value, setValue] = useState<string>("");
  const [error, setError] = useState<string>("");

  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    let input = e.target.value;

    // Убираем все символы, кроме цифр и плюса
    input = input.replace("+", "");
    // Проверка длины (не более 25 символов, включая +)
    if (
      input.length <= 25 &&
      /^\d{1,24}$/.test(input)
    ) {
      setValue(input);
      setError("");
    } else {
      setError(
        "Номер телефона должен содержать не менее 11 и не более 25 цифр."
      );
    }
  }

  const onclkbtn = () => {
    if (value.trim() === "" || value.length <10) {
      setError(
        "Номер телефона должен содержать не менее 11 и не более 25 цифр."
      );
    } else {
      props.onclkbtn(value);
    }
  };

  return (
    <>
      <div className="RegistrationConteinerText">
        <div className="textConteiner">
          <h2>Ваш номер телефона</h2>
          <p>
            Нам важно оставаться с вами на связи во время этого удивительного
            путешествия
          </p>
          <input
            type="text"
            id="phone"
            value={"+"+value}
            onChange={handleChange}
            placeholder="Телефон"
            required
            autoFocus
            maxLength={25}
            onKeyUp={(e) => {
              if (e.code === "Enter") {
                onclkbtn();
              }
            }}
          />
          {error && <p className="error-message">{error}</p>}
        </div>
      </div>
      <div className="registration-button" onClick={onclkbtn}>
        Далее
      </div>
    </>
  );
}
